AFRAME.registerComponent('watchlist-settings-popup', {
    schema: {},

    init: function () {        
        if (window.PopupManager) {
            window.PopupManager.register('watchlist-settings-popup', this.el);
        }
        this.bgDark = this.el.querySelector('.background-panel-dark');
        this.bgLight = this.el.querySelector('.background-panel-light');

        this.createHeader();
        this.createSettingsList();

        this.el.sceneEl.addEventListener('theme-changed', () => {
            this.createHeader();
            this.createSettingsList();
            this.updateBackgroundVisibility();
        });
        
        this.updateBackgroundVisibility();
    },

    updateBackgroundVisibility: function () {
        const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        const isLight = settings && settings.themeMode === 'Light';
        
        if (this.bgDark) this.bgDark.setAttribute('visible', !isLight);
        if (this.bgLight) this.bgLight.setAttribute('visible', isLight);
    },

    createHeader: function () {
        let headerContainer = this.el.querySelector('.header-container');
        if (!headerContainer) {
            headerContainer = document.createElement('a-entity');
            headerContainer.className = 'header-container';
            this.el.appendChild(headerContainer);
        }
        headerContainer.innerHTML = '';

        const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        const isLight = settings && settings.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Watchlist Settings');
        title.setAttribute('font-size', 0.03);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', '0 0.27 0.01');
        headerContainer.appendChild(title);

        const cross = document.createElement('a-troika-text');
        cross.setAttribute('value', '×');
        cross.setAttribute('font-size', 0.04);
        cross.setAttribute('color', txtColor);
        cross.setAttribute('anchor', 'center');
        cross.setAttribute('position', '0.26 0.27 0.01');
        headerContainer.appendChild(cross);

        const closeArea = document.createElement('a-plane');
        closeArea.setAttribute('width', 0.04);
        closeArea.setAttribute('height', 0.04);
        closeArea.setAttribute('opacity', 0);
        closeArea.setAttribute('position', '0.26 0.27 0.011');
        closeArea.setAttribute('data-raycastable', '');
        closeArea.addEventListener('click', () => {
            if (window.PopupManager) {
                window.PopupManager.close('watchlist-settings-popup');
            } else {
                this.el.setAttribute('visible', false);
            }
        });
        headerContainer.appendChild(closeArea);
    },

    createSettingsList: function () {
        let contentEl = this.el.querySelector('.content-container');
        if (!contentEl) {
            contentEl = document.createElement('a-entity');
            contentEl.className = 'content-container';
            this.el.appendChild(contentEl);
        }
        contentEl.innerHTML = '';

        const State = (window.WatchlistApp && window.WatchlistApp.State) || {};
        const currentSort = State.currentSortOption || 'alphabetical';
        const currentOrder = State.currentSortOrder || 'asc';

        const itemWidth = 0.56;
        const padding = 0.02;
        const rowHeight = 0.045;
        
        const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        const isLight = settings && settings.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const createLabel = (text, y) => {
            const label = document.createElement('a-troika-text');
            label.setAttribute('value', text);
            label.setAttribute('font-size', 0.018);
            label.setAttribute('color', txtColor);
            label.setAttribute('anchor', 'left');
            label.setAttribute('position', `${-itemWidth / 2 + padding} ${y} 0.01`);
            contentEl.appendChild(label);
        };

        const sortYStart = -0.16;
        createLabel('Sort By', sortYStart);
        
        const sortOptions = [
            { label: 'Symbol', value: 'alphabetical' },
            { label: 'Total $ Value Change', value: 'total_dollar_value_change' },
            { label: 'Price Change $', value: 'price_change_dollar' },
            { label: 'Value Change', value: 'value_change' },
            { label: 'Total % Price Change', value: 'total_percent_price_change' },
            { label: 'Price Change %', value: 'price_change_percent' },
        ];

        sortOptions.forEach((opt, i) => {
            const btn = document.createElement('a-entity');
            const col = i % 2;
            const row = Math.floor(i / 2);
            const x = -0.14 + col * 0.28;
            const y = sortYStart - 0.05 - row * 0.065;
            
            const isSelected = (opt.value === currentSort);
            
            btn.setAttribute('ui-button', {
                label: opt.label,
                width: 0.26,
                height: rowHeight,
                depth: 0.02,
                type: 'rounded-box',
                colorScheme: 'primary',
                selected: isSelected,
                radius: 0.01,
                preferredFontSize: 0.016
            });
            btn.setAttribute('position', `${x} ${y} 0.02`);
            btn.addEventListener('click', () => {
                if (window.WatchlistApp && window.WatchlistApp.State) {
                    window.WatchlistApp.State.currentSortOption = opt.value;
                    this.createSettingsList();
                    this.refreshTable();
                }
            });
            contentEl.appendChild(btn);
        });

        const orderYStart = sortYStart - 0.26;
        createLabel('Order', orderYStart);

        const orderOptions = [
            { label: 'Ascending', value: 'asc' },
            { label: 'Descending', value: 'desc' }
        ];

        orderOptions.forEach((opt, i) => {
            const btn = document.createElement('a-entity');
            const x = -0.14 + i * 0.28;
            const y = orderYStart - 0.05;
            
            const isSelected = (opt.value === currentOrder);
            
            btn.setAttribute('ui-button', {
                label: opt.label,
                width: 0.26,
                height: rowHeight,
                depth: 0.02,
                type: 'rounded-box',
                colorScheme: 'primary',
                selected: isSelected,
                radius: 0.01,
                preferredFontSize: 0.016
            });
            btn.setAttribute('position', `${x} ${y} 0.02`);
            btn.addEventListener('click', () => {
                if (window.WatchlistApp && window.WatchlistApp.State) {
                    window.WatchlistApp.State.currentSortOrder = opt.value;
                    this.createSettingsList();
                    this.refreshTable();
                }
            });
            contentEl.appendChild(btn);
        });
    },

    refreshTable: function () {
        this.el.sceneEl.emit('watchlist-table-request-data');
    }
});
